"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

require("slick-carousel");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var dittoVto = function () {
  function dittoVto(initialVariant) {
    (0, _classCallCheck3.default)(this, dittoVto);

    var _JSON$parse = JSON.parse(document.getElementById("ShopifyData").innerHTML),
        customer = _JSON$parse.customer,
        product = _JSON$parse.product;

    this.customer = customer;
    this.product = product;
    this.retake = false;
    this.scanId = this.getDittoId();
    this.initialVariant = initialVariant;

    this.retakeButton = ".js-retake-ditto";
    this.modalTrigger = ".js-toggle-ditto";
    this.lifestyle = ".js-lifestyle-gallery";
    this.track = ".js-lifestyle-gallery .slick-track";
    this.popup = ".js-ditto-popup";

    this.toggleListener();
  }

  (0, _createClass3.default)(dittoVto, [{
    key: "toggleListener",
    value: function toggleListener() {
      var _this = this;

      var modalTrigger = this.modalTrigger,
          initialVariant = this.initialVariant;

      var toggle = document.querySelector(modalTrigger);
      if (toggle) {
        toggle.addEventListener("click", function () {
          _this.addUpdateSlide(initialVariant);
        });
        toggle.addEventListener("keydown", function (event) {
          return event.keyCode === 13 ? _this.addUpdateSlide(initialVariant) : false;
        });
      }
    }
  }, {
    key: "addUpdateSlide",
    value: function addUpdateSlide(variantData) {
      var scanId = this.scanId,
          track = this.track,
          lifestyle = this.lifestyle,
          modalTrigger = this.modalTrigger,
          retake = this.retake,
          popup = this.popup;

      var testForSlide = document.getElementById("dittoDisplay");
      var lifestyleSlider = document.querySelector(lifestyle);
      var toggle = document.querySelector(modalTrigger);
      var slideTrack = document.querySelector(track);
      var dittoPopup = document.querySelector(popup);
      var div = "";
      // Check compatibility flow
      var dittoFlowTypeTest = Ditto.flowType;

      toggle.classList.add("hide");

      if (testForSlide) {
        div = testForSlide;
      } else {
        div = document.createElement("div");
        div.id = "dittoDisplay";
        div.style.height = slideTrack.offsetHeight + "px";
      }

      (0, _jquery2.default)(lifestyleSlider).slick("slickAdd", div, 0, "addBefore");

      console.log(dittoFlowTypeTest);
      if (dittoFlowTypeTest == "COMPATIBILITY") {
        document.querySelector("#DittoPopup").style.display = "none";
      }

      if (scanId === "" || retake) {
        dittoPopup.classList.add("active");
        this.createTryOnView("#DittoPopup", variantData.sku);
        (0, _jquery2.default)(lifestyleSlider).slick("slickGoTo", 0);
      } else {
        this.displayTryOnFrontal("#dittoDisplay", variantData.sku, scanId);
        (0, _jquery2.default)(lifestyleSlider).slick("slickGoTo", 0);
      }
    }
  }, {
    key: "createTryOnView",
    value: function createTryOnView(domSelector, glassesId) {
      var _this2 = this;

      var popup = this.popup,
          scanId = this.scanId,
          modalTrigger = this.modalTrigger;

      var dittoPopup = document.querySelector(popup);
      var toggle = document.querySelector(modalTrigger);
      // Check compatibility flow
      var dittoFlowTypeTest = Ditto.flowType;

      _jquery2.default.get("/tools/auth_key/ditto-auth-credentials/", function (response) {
        var dittoCreation = new Ditto.Scan({
          tryOnServer: "https://vto.partners-au.api.ditto.com",
          domSelector: domSelector,
          accessKey: response["X-Ditto-Access-Key-Id"],
          partnerId: "sunniesstudios",
          font: "montserrat",
          partnerSignature: response["X-Ditto-Signature"],
          enableFaceInsights: true
        }, {
          success: function success(callbackObject) {
            dittoPopup.classList.remove("active");
            if (dittoFlowTypeTest == "COMPATIBILITY") {
              alert("SUCCESS");
              document.querySelector("#DittoPopup").style.display = "block";
              document.querySelector("#scan-iframe").style.zIndex = "2";
            }
            _this2.displayTryOnFrontal("#dittoDisplay", glassesId, callbackObject.scanId);
            dittoCreation.destroy();
            _this2.saveDittoId(callbackObject.scanId);
            document.querySelector("html").classList.remove("no-scroll");

            (0, _jquery2.default)("html, body").animate({
              scrollTop: (0, _jquery2.default)(".Product__header").offset().top - (0, _jquery2.default)("header").outerHeight()
            }, 2000);
          },
          failure: function failure(callbackObject) {
            console.log("failure", callbackObject);
          },
          progress: function progress(callbackObject) {
            console.log("progress", callbackObject);
            document.querySelector("html").classList.add("no-scroll");

            if (dittoFlowTypeTest == "COMPATIBILITY") {
              document.querySelector("#scan-iframe").style.zIndex = "10";
            }
          },
          close: function close(callbackObject) {
            console.log("close", callbackObject);
            document.querySelector("#DittoPopup").style.display = "initial";

            var testForSlide = document.getElementById("dittoDisplay");

            document.querySelector("html").classList.remove("no-scroll");
            dittoPopup.classList.remove("active");
            if (scanId !== "") {
              _this2.displayTryOnFrontal("#dittoDisplay", glassesId, scanId);
            } else if (scanId === "" && testForSlide) {
              testForSlide.parentNode.removeChild(testForSlide);
              toggle.classList.remove("hide");
            }
          }
        });
      });
    }
  }, {
    key: "displayTryOnFrontal",
    value: function displayTryOnFrontal(domSelector, glassesId, scanId) {
      var self = this;
      var retakeButton = this.retakeButton;
      // Check compatibility flow

      var dittoFlowTypeTest = Ditto.flowType;

      _jquery2.default.get("/tools/auth_key/ditto-auth-credentials/?message=" + scanId, function (response) {
        var dittoTryOn = new Ditto.Overlay({
          tryOnServer: "https://vto.partners-au.api.ditto.com",
          partnerId: "sunniesstudios",
          domSelector: domSelector,
          scanId: scanId,
          glassesId: glassesId,
          accessKey: response["X-Ditto-Access-Key-Id"],
          partnerSignature: response["X-Ditto-Signature"],
          overlaySignature: response["X-Ditto-Signature"]
        }, {
          success: function success(data) {
            var wrapper = document.getElementById("dittoDisplay");
            var removeRetakeButton = document.querySelector(".js-retake-ditto");

            if (removeRetakeButton) {
              wrapper.removeChild(removeRetakeButton);
            }

            var button = document.createElement("button");
            button.type = "button";
            button.classList.add("Product__details-lifestyle__ditto", "btn", "js-retake-ditto", "btn--black");
            button.innerText = "Retake";
            document.getElementById("dittoDisplay").appendChild(button);

            var buttonHint = document.getElementById("dittoHint");
            if (buttonHint) {
              document.getElementById("dittoDisplay").appendChild(buttonHint);
              buttonHint.classList.add("show-hint");
            }

            var retakeButtonElement = document.querySelector(retakeButton);
            retakeButtonElement.addEventListener("click", function () {
              self.triggerRetake();
            });
            retakeButtonElement.addEventListener("keydown", function (event) {
              return event.keyCode === 13 ? self.triggerRetake() : false;
            });
          },
          failure: function failure() {
            console.log("failure");
          }
        });
      });
    }
  }, {
    key: "triggerRetake",
    value: function triggerRetake() {
      var retakeButton = this.retakeButton,
          initialVariant = this.initialVariant;

      var retakeButtonElement = document.querySelector(retakeButton);

      retakeButtonElement.remove();

      this.retake = true;
      this.addUpdateSlide(initialVariant);
    }
  }, {
    key: "saveDittoId",
    value: function saveDittoId(scanId) {
      var date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      var expires = date.toUTCString();
      this.scanId = scanId;
      document.cookie = "ditto_id=" + scanId + "; expires=" + expires + "; SameSite=Strict; path=/";
    }
  }, {
    key: "getDittoId",
    value: function getDittoId() {
      var value = document.cookie.split(";").filter(function (cookie) {
        var key = cookie.split("=")[0].trim();
        var pair = cookie.split("=")[1].trim();

        return key === "ditto_id" ? pair : false;
      });

      if (value.length > 0) {
        return value[0].split("=")[1].trim();
      } else {
        return "";
      }
    }
  }]);
  return dittoVto;
}();

exports.default = dittoVto;